import { forwardRef, ReactElement, Ref } from "react";
import { EditGenericWithDestinationWindowTile, EditGenericWithDestinationWindowTilePropsBase } from "./EditGenericWithDestinationWindowTile";
import { EditTileHandle } from "./EditTile";
import { updateZermeloTile, ZermeloDetailsTileModel } from "client/Api/Workspace/workspace";

export type EditZermeloTileProps = EditGenericWithDestinationWindowTilePropsBase<ZermeloDetailsTileModel>;

export const EditZermeloTile = forwardRef(
	(props: EditZermeloTileProps, ref: Ref<EditTileHandle>): ReactElement => {

		return (
			<EditGenericWithDestinationWindowTile
				{...props}
				requestHandler={updateZermeloTile}
				ref={ref}
			/>
		);
	}
);
EditZermeloTile.displayName = "EditZermeloTile";
